import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (email: string, emailConfirmation: string) => void;
};

export const ForgotPasswordForm: React.FC<Props> = ({ handleSubmit }) => {
  const schema = useMemo(() => {
    return z
      .object({
        email: z.string().min(1),
        emailConfirmation: z.string().min(1),
      })
      .refine((data) => data.email === data.emailConfirmation);
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{
        email: "",
        emailConfirmation: "",
      }}
      onSubmit={({ email, emailConfirmation }) =>
        handleSubmit(email, emailConfirmation)
      }
    >
      <Wrapper>
        <InputContainer>
          <Input
            name="email"
            type="email"
            label="ご登録のメールアドレス"
            required
            dataWovnIgnore={true}
          />
        </InputContainer>
        <InputContainer>
          <Input
            name="emailConfirmation"
            type="email"
            label={`確認のためメールアドレスを \n再入力してください`}
            required
            dataWovnIgnore={true}
          />
        </InputContainer>
      </Wrapper>

      <ButtonWrapper>
        <Button type="submit" text="送信" btnStyle="primary" />
      </ButtonWrapper>
    </FormTemplate>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 41px;
  margin-bottom: 12px;
  button {
    font-weight: 500;
    line-height: 1em;
    height: auto;
    font-family: "Hiragino Sans";
  }
`;

const Wrapper = styled.div`
  overflow: hidden;
`;

const InputContainer = styled.div`
  margin-bottom: 20px;
`;
